import { useEffect, useRef } from 'react';
import { isDesktopMacOSUserAgent, isIOSNativeApp } from '../utils/platform';
import { isConnectorAvailable } from '../lib/connector';
import { isTypingTarget } from '../keyboard/jriverShortcutMap';
import { requestAddMusic } from '../services/addMusicRequest';

/** Cmd+O on macOS, Ctrl+O elsewhere. */
export function isAddMusicShortcut(e) {
  if (e.key !== 'o' && e.key !== 'O') return false;
  if (e.altKey || e.shiftKey) return false;
  return isDesktopMacOSUserAgent() ? e.metaKey && !e.ctrlKey : e.ctrlKey && !e.metaKey;
}

/** Global Ctrl/Cmd+O → open the Add Music (Volumes) window, same as sidebar Add Music. */
export default function useAddMusicShortcut(nav) {
  const navRef = useRef(nav);
  navRef.current = nav;
  useEffect(() => {
    if (isIOSNativeApp()) return undefined;
    const onKeyDown = (e) => {
      if (e.defaultPrevented || !isAddMusicShortcut(e) || isTypingTarget(e.target)) return;
      if (!isConnectorAvailable()) return;
      e.preventDefault();
      requestAddMusic();
      navRef.current?.goLocalLibrary?.('manage');
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);
}
